export default class JsonLoader {
  async load(file) {
    const data = await fetch(file.computedPath)
    const json = await data.json()
    return json
  }
}
